export const phieuXuatKho = {
  sections: {
    list: { title: 'Stock-out vouchers' },
    xuatHuy: { title: 'Disposal vouchers' },
    xuatTraNcc: { title: 'Return-to-supplier vouchers' },
    detail: { title: 'Stock-out details' },
    lines: 'Line items',
  },
  titles: {
    add: 'Add new',
    addNew: 'Add new',
    addXuatHuy: 'Create disposal voucher',
    addXuatTraNcc: 'Create return-to-supplier voucher',
  },
  columns: {
    tongSoLuong: 'Total qty',
    summary: 'Summary',
    status: 'Status',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    code: 'Voucher no.',
    chiNhanh: 'Branch',
    loaiPhieu: 'Type',
    ngayChungTu: 'Voucher date',
    nhaCungCap: 'Supplier',
    khachHang: 'Customer',
    chiNhanhDoi: 'Counter branch',
    trangThai: 'Status',
    tongTienHang: 'Subtotal',
    maHoaDon: 'Invoice no.',
  },
  placeholders: {
    toolbarSearch: 'Search',
    maLoRequired: 'Required (expiry-managed product)',
    maLoOptional: 'Leave empty if not lot-tracked',
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
  fields: {
    code: 'Voucher no.',
    chiNhanh: 'Branch',
    loaiPhieu: 'Type',
    ngayChungTu: 'Voucher date',
    nhaCungCap: 'Supplier',
    khachHang: 'Customer',
    chiNhanhDoi: 'Counter branch',
    lyDo: 'Reason',
    ghiChu: 'Note',
    phieuChuyen: 'Transfer voucher',
    status: 'Status',
    totalAmount: 'Subtotal',
    product: 'Product',
    productCode: 'SKU',
    productName: 'Name',
    productSearch: 'Search product',
    qty: 'Qty',
    unitPrice: 'Issue price',
    donGiaXuatKho: 'Issue price',
    donGiaVon: 'Cost price',
    donViTinhMua: 'UoM',
    giamGia: 'Discount',
    giamGiaPhieu: 'Voucher discount',
    tongSauGiamGia: 'Net amount',
    maLo: 'Serial/IMEI',
    hanSuDung: 'Product date',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Product date',
    lineAmount: 'Line total',
    lineGhiChu: 'Note',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    actions: 'Actions',
  },
  loaiPhieu: {
    XUAT_BAN: 'Sales out',
    XUAT_CHUYEN: 'Transfer out',
    XUAT_TRA_NCC: 'Return to supplier',
    XUAT_HUY: 'Scrap out',
    XUAT_NOI_BO: 'Internal out',
    XUAT_DIEU_CHINH: 'Adjustment out',
    XUAT_KHAC: 'Other out',
  },
  detailTabs: {
    chung: 'Overview',
    generalInfo: 'Info',
    chiTietHang: 'Line items',
    lines: 'Line items',
  },
  form: {
    loaiPhieu: 'Type',
    maPhieu: 'Voucher no.',
    maPhieuAuto: 'Auto-generated on save',
    ngayChungTu: 'Voucher date',
    nhaCungCap: 'Supplier',
    khachHang: 'Customer',
    chonKhachHang: 'Select customer',
    chiNhanhDoi: 'Counter branch',
    lyDo: 'Reason',
    ghiChu: 'Voucher note',
    note: 'Voucher note',
    sectionHeader: 'General info',
    sectionLines: 'Line items',
    sectionSummary: 'Summary',
    product: 'Product',
    productSearch: 'Search code / name',
    qty: 'Qty',
    unitPrice: 'Issue price',
    donGiaXuatKho: 'Issue price',
    donGiaVon: 'Cost price',
    donViTinhMua: 'UoM',
    maSp: 'SKU',
    tenSp: 'Name',
    giamGia: 'Discount',
    giamGiaPhieu: 'Voucher discount',
    tongSauGiamGia: 'Net amount',
    maLo: 'Serial/IMEI',
    hanSuDung: 'Product date',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Product date',
    lineNote: 'Note',
    lineAmount: 'Line amount',
    tongTienHang: 'Subtotal',
    tongSoMatHang: 'Items',
    tongSoLuong: 'Total qty',
    lineCount: '{count} lines',
    save: 'Save',
    lotRequired: 'Lot no. required (expiry-managed)',
    expiryRequired: 'Expiry date required (expiry-managed)',
  },
  status: {
    phieuTam: 'Draft',
    daHoanThanh: 'Issued',
    daHuy: 'Cancelled',
  },
  filter: {
    maKhachHang: 'Customer code',
    tenKhachHang: 'Customer name',
    maHangHoa: 'Product code',
    tenHangHoa: 'Product name',
    title: 'Filter',
    loaiPhieu: 'Type',
    trangThai: 'Status',
    khachHang: 'Customer',
    tuNgay: 'From date',
    denNgay: 'To date',
    fromDate: 'From date',
    toDate: 'To date',
    dateRangePlaceholder: 'Select date range',
    all: 'All',
    reset: 'Reset',
    sortDir: 'Order',
    asc: 'Ascending',
    desc: 'Descending',
    advancedTitle: 'Advanced filters',
  },
  actions: {
    addLine: 'Add empty line',
    complete: 'Complete',
    cancelVoucher: 'Cancel voucher',
    copy: 'Copy voucher',
    importExcel: 'Import Excel',
    downloadTemplate: 'Download template',
    dongY: 'Agree',
  },
  messages: {
    soKhongDuocAm: 'Quantity / unit price cannot be negative.',
    importDescription:
      'Download the template, fill product code / qty / unit price / discount. One file creates one draft. Import directly or preview to edit first.',
    importSuccess: 'Imported products from Excel.',
    importWillCreate: 'Will create 1 goods issue from {count} line(s).',
    importPreviewProgress: 'Preview goods issue',
    importPreviewLoading: 'Preparing goods issue…',
    importPreviewDone: 'Goods issue created from preview.',
    loadError: 'Failed to load stock-out vouchers.',
    noData: 'No stock-out vouchers yet.',
    listSummary: 'Total: {count}',
    createSuccess: 'Stock-out voucher created and stock deducted.',
    updateSuccess: 'Stock-out voucher updated.',
    deleteSuccess: 'Stock-out voucher deleted.',
    needLines: 'Add at least one line item.',
    needNgayChungTu: 'Select a voucher date before saving.',
    validateNgayChungTuBeforeNgayTao: 'Invalid voucher date.',
    needKhachHang: 'Select a customer before saving.',
    needNhaCungCap: 'Select a supplier before saving.',
    needChiNhanhDoi: 'Select a counter branch before saving.',
    needMaSp: 'Enter SKU for every line.',
    needTenSp: 'Enter product name for every line.',
    needSoLuong: 'Enter quantity (> 0) for every line.',
    needDonViTinhMua: 'Enter UoM for every line.',
    needMaLo: 'Enter Serial/IMEI for {code}.',
    needHanSuDung: 'Enter product date for {code}.',
    completeSuccess: 'Stock-out voucher completed.',
    cancelVoucherSuccess: 'Stock-out voucher cancelled.',
    notFound: 'Voucher not found.',
    noLines: 'No line items.',
    loadingLines: 'Loading lines…',
    confirmDelete: 'Delete {name}?',
    confirmComplete: 'Complete voucher {name}? Stock will be updated.',
    vuotTonTitle: 'Quantity exceeds stock — stock will become negative',
    vuotTonDong: '{ma} – {ten}: issue {soLuong}, in stock {ton}',
    confirmCancelVoucher: 'Cancel voucher {name}? Deducted stock will be restored. This cannot be undone.',
  },
}
